import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {TruncateTooltipCellComponent} from "@irb-common/components/grid/renderers/truncatetooltip.cell.component";
import {CustomfilterComponent} from "@irb/irb-clients/portfolios/customfilter/customfilter.component";
import {IrbAgSetColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component";
import {RequiredTextboxEditor} from "@irb-common/components/grid/editors/required-textbox-editor";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {DropdownFilterRendererComponent} from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import {SettingsMmcNotesComponent} from "@irb/irb-settings/settings-mmc/settings-mmc-notes/settings-mmc-notes.component";


@Injectable({
    providedIn: "root"
})
export class SettingsMmcNotesGridLayoutService implements GridLayoutService<SettingsMmcNotesComponent> {
    sizeFor: any;

    getFrameworkComponents(): any {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "customFilterToolPanel": CustomfilterComponent,
            "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent,
            "RequiredTextboxEditor": RequiredTextboxEditor,
            "DropdownFilterRendererComponent": DropdownFilterRendererComponent
        };
    }

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "symbol": 60
        };
    }

    getColumnDefs(parent: SettingsMmcNotesComponent) {
        return [
            {
                headerName: 'Delete All',
                headerComponent: 'DeleteHeaderComponent',
                headerComponentParams: {
                    message: "Delete all notes?",
                    proceed: parent.deleteAll.bind(parent),
                    cancel: parent.cancelDelete.bind(parent),
                    disableDelete: parent.modelMarketNotifications?.filter((x: any) => !x.isUIdeleted)?.length > 0

                },
                cellRenderer: "DeleteCellComponent",
                cellRendererParams: {
                    message: "Delete this note?",
                    proceed: parent.delete.bind(parent),
                    cancel: parent.cancelDelete.bind(parent)
                },
                resizable: false,
                minWidth: 25,
                maxWidth: 25,
                width: 25,
                pinned: "left",
                suppressColumnsToolPanel: true,
                lockPosition: true,
                colId: 'deleteAssetClass'
            },
            {
                headerName: "Timestamp",
                field: "createdDate",
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
                minWidth: 150,
                suppressMovable: true,
                sortable: false,
                pinned: "left",
                sort: 'desc',
            },
            {
                headerName: "Creator",
                field: "creator",
                minWidth: 70,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false,
                sortable: false,
                pinned: "left",
            },
            {
                headerName: "Manager Name",
                field: "modelProviderName",
                minWidth: 70,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false,
                sortable: false,
                pinned: "left",
            },
            {
                headerName: "Model Name",
                field: "modelMarketName",
                minWidth: 70,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: false,
                sortable: false,
                pinned: "left",
                valueGetter: this.formatModelName,
            },
            {
                headerName: "Note",
                field: "comment",
                editable: true,
                cellEditor: 'agLargeTextCellEditor',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: 'TruncateTooltipCellComponent',
                tooltipPosition: 'bottom',
                cellEditorParams: {
                    maxLength: 1000,
                    required: true,
                    autofocus: true,
                    width: '100%',
                    tooltiptext: 'Please enter a note'
                },
                sortable: false,
                sort: 'asc',
                colId: 'comment',
                pinned: "left",
            }, {
                headerName: 'Priority',
                field: 'priority',
                minWidth: 160,
                suppressMovable: true,
                sortable: false,
                cellClass: 'dropdownFilterCell',
                cellRenderer: 'DropdownFilterRendererComponent',
                cellRendererParams: (params: any) => {
                    return {
                        defaultValue: this.getDefaultPriorityType(params.data.priority),
                        values: [
                            {value: "Normal", name: "Normal"},
                            {value: "Medium", name: "Medium"},
                            {value: "High", name: "High"}
                        ],
                        onChange: (params: any, item: IDropdownItem) => {
                            params.data.priority = item.value;
                            params.api.redrawRows({rowNodes: [params.node]});
                            parent.onPriorityChanged(params);
                        }
                    };
                }
            },
        ];
    }

    getDefaultPriorityType(priority: any) {
        let defaultValue: any;
        let values: any[] = [
            {value: "Normal", name: "Normal"},
            {value: "Medium", name: "Medium"},
            {value: "High", name: "High"}
        ];
        let index = values.findIndex(x => x.value === priority);
        if (index >= 0) {
            defaultValue = values[index];
        } else {
            defaultValue = {value: "Normal", name: "Normal"}
        }
        return defaultValue;
    }

    formatModelName(params: any) {
        if (params.data.modelMarketName) {
            return params.data.modelMarketName;
        } else {
            return "All";
        }

    }

}
